import React from "react";
import BreadCrumb from "../screens/Common/BreadCrumb";

import LayoutContainer from "../screens/layout/admin-dashboard";
import UsersList from "../screens/Users1/UsersList";

const breadCrumbData = [{ link: "/usersview", name: "Users" }];

const QuestionList = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <UsersList />
    </LayoutContainer>
  </>
);

export default QuestionList;
